import { makeStyles } from '@material-ui/core/styles';

export const useRphoneStyles = makeStyles(() => ({
  title: {
    fontSize: 26,
    fontWeight: 600,
    textAlign: 'center',
    marginBottom: 30,
    color: '#464646',
  },
  subtitle: {
    color: '#464646',
    textAlign: 'center',
    marginTop: 10,
  },
  text: {
    textAlign: 'center',
  },
}));
